import { useToggle } from "react-use"
import { useNavigate, useLocation } from "react-router-dom"
import { useEffect, useState } from "react"

import { DatePickerError, OnlineOrOffline } from "modules/BookingCommon/common/interfaces"
import { Pages } from "modules/BookingCommon/common/constants"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { OfferedService } from "utils/interfaces"
import { useGetCurrentPage } from "modules/Booking/common/hooks/useGetCurrentPage"

interface Props {
    initialPage: Pages
    amountOfPages: Pages[]
    isBookingAvailable: boolean
}

export function useBooking({ initialPage, amountOfPages }: Props) {
    const navigate = useNavigate()
    const location = useLocation()
    const [selectedTime, changeSelectedTime] = useState(new Date())
    const [slotId, setSlotId] = useState<string>()
    const [slotDuration, setSlotDuration] = useState<number>()
    const [serviceGroup, setServiceGroup] = useState<ServicesGroup | undefined>()
    const [onlineOrOffline, setOnlineOrOffline] = useState<OnlineOrOffline | undefined>()
    const [selectedService, setSelectedService] = useState<OfferedService | undefined>()
    const currentPage = useGetCurrentPage() || initialPage

    const [datePickerError, setDatePickerError] = useState<DatePickerError | undefined>()
    const [datePickerIsLoaded, toggleDatePickerIsLoaded] = useToggle(false)
    const [currentWeek, setCurrentWeek] = useState<Date | undefined>()

    const indexOfCurrentPage = amountOfPages.findIndex((i) => i === currentPage)

    const url = location.pathname + location.search

    function nextPage() {
        const nextPageName = amountOfPages[indexOfCurrentPage + 1]
        navigate(url, {
            state: {
                bookingPage: nextPageName,
            },
        })
    }

    function setPage(page: Pages) {
        if (amountOfPages.includes(page)) {
            navigate(url, { state: { bookingPage: page } })
        }
    }

    useEffect(() => {
        navigate(url, {
            state: {
                bookingPage: currentPage,
            },
            replace: true,
        })
    }, [])

    return {
        selectedTime,
        changeSelectedTime,
        slotId,
        setSlotId,
        slotDuration,
        setSlotDuration,
        serviceGroup,
        setServiceGroup,
        onlineOrOffline,
        setOnlineOrOffline,
        selectedService,
        setSelectedService,
        currentPage,
        datePickerError,
        setDatePickerError,
        datePickerIsLoaded,
        toggleDatePickerIsLoaded,
        currentWeek,
        setCurrentWeek,
        indexOfCurrentPage,
        nextPage,
        setPage,
    }
}
